import { INode } from 'shared/types/tree'

// Returns only the node values that might be updated when updating node content
export const filterNodeForParams = (
  node: Pick<INode, 'description' | 'body' | 'title'>,
) => {
  return {
    description: node.description,
    title: node.title,
    body: { ...node.body },
  }
}
